// Area mapping
// No two can have same stallId
//

import { HALL_KEYS_CONSTANT_DATA } from "./AreaOptionData";

/* Old Hall_Jio_layoutData (pre floorMap update) — preserved for reference
const Hall_Jio_layoutData =[
  {
    "stallId": "StallJIO-A_1a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
}]
*/

const HallJasmine_layoutData = [
  {
    Index: 1,
    stallId: "StallClub_10A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 2,
    stallId: "StallClub_10B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 3,
    stallId: "StallClub_11A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 4,
    stallId: "StallClub_11B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 5,
    stallId: "StallClub_11C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 6,
    stallId: "StallClub_11D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 7,
    stallId: "StallClub_12A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 8,
    stallId: "StallClub_12B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 9,
    stallId: "StallClub_12C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 10,
    stallId: "StallClub_12D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 11,
    stallId: "StallClub_13A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 12,
    stallId: "StallClub_13B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 13,
    stallId: "StallClub_13C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 14,
    stallId: "StallClub_13D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 15,
    stallId: "StallClub_14A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 16,
    stallId: "StallClub_14B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 17,
    stallId: "StallClub_14C",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 18,
    stallId: "StallClub_14D",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 19,
    stallId: "StallClub_15A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 20,
    stallId: "StallClub_15B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 21,
    stallId: "StallClub_15C",
    area: 72,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X12",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 22,
    stallId: "StallClub_16A",
    area: 48,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X8",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 23,
    stallId: "StallClub_16B",
    area: 48,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X8",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 24,
    stallId: "StallClub_17A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 25,
    stallId: "StallClub_17B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 26,
    stallId: "StallClub_17C",
    area: 48,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X8",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 27,
    stallId: "StallClub_18A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 28,
    stallId: "StallClub_18B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 29,
    stallId: "StallClub_18C",
    area: 48,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X8",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 30,
    stallId: "StallClub_19A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 31,
    stallId: "StallClub_19B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 32,
    stallId: "StallClub_1A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 33,
    stallId: "StallClub_1B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 34,
    stallId: "StallClub_20A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 35,
    stallId: "StallClub_20B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 36,
    stallId: "StallClub_21A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 37,
    stallId: "StallClub_21B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 38,
    stallId: "StallClub_21C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 39,
    stallId: "StallClub_21D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 40,
    stallId: "StallClub_22A",
    area: 48,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X8",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 41,
    stallId: "StallClub_22B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 42,
    stallId: "StallClub_22C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 43,
    stallId: "StallClub_23A",
    area: 48,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X8",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 44,
    stallId: "StallClub_23B",
    area: 48,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X8",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 45,
    stallId: "StallClub_24A",
    area: 72,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X12",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 46,
    stallId: "StallClub_24B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 47,
    stallId: "StallClub_24C",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 48,
    stallId: "StallClub_25A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 49,
    stallId: "StallClub_25B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 50,
    stallId: "StallClub_25C",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 51,
    stallId: "StallClub_25D",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 52,
    stallId: "StallClub_26A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 53,
    stallId: "StallClub_26B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 54,
    stallId: "StallClub_26C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 55,
    stallId: "StallClub_26D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 56,
    stallId: "StallClub_27A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 57,
    stallId: "StallClub_27B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 58,
    stallId: "StallClub_27C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 59,
    stallId: "StallClub_27D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 60,
    stallId: "StallClub_28A",
    area: 60,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X10",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 61,
    stallId: "StallClub_28B",
    area: 60,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X10",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 62,
    stallId: "StallClub_29A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 63,
    stallId: "StallClub_29B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 64,
    stallId: "StallClub_2A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 65,
    stallId: "StallClub_2B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 66,
    stallId: "StallClub_30A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 67,
    stallId: "StallClub_30B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 68,
    stallId: "StallClub_30C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 69,
    stallId: "StallClub_30D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 70,
    stallId: "StallClub_31A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 71,
    stallId: "StallClub_31B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 72,
    stallId: "StallClub_31C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 73,
    stallId: "StallClub_31D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 74,
    stallId: "StallClub_32A",
    area: 72,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X12",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 75,
    stallId: "StallClub_32B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 76,
    stallId: "StallClub_32C",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 77,
    stallId: "StallClub_33A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 78,
    stallId: "StallClub_33B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 79,
    stallId: "StallClub_33C",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 80,
    stallId: "StallClub_33D",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 81,
    stallId: "StallClub_34A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 82,
    stallId: "StallClub_34B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 83,
    stallId: "StallClub_34C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 84,
    stallId: "StallClub_34D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 85,
    stallId: "StallClub_35A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 86,
    stallId: "StallClub_35B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 87,
    stallId: "StallClub_35C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 88,
    stallId: "StallClub_35D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 89,
    stallId: "StallClub_36A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 90,
    stallId: "StallClub_36B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 91,
    stallId: "StallClub_37A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 92,
    stallId: "StallClub_37B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 93,
    stallId: "StallClub_38A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 94,
    stallId: "StallClub_38B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J2",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 95,
    stallId: "StallClub_3A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 96,
    stallId: "StallClub_3B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 97,
    stallId: "StallClub_4A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 98,
    stallId: "StallClub_4B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 99,
    stallId: "StallClub_4C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 100,
    stallId: "StallClub_4D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 101,
    stallId: "StallClub_5A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 102,
    stallId: "StallClub_5B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 103,
    stallId: "StallClub_5C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 104,
    stallId: "StallClub_5D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 105,
    stallId: "StallClub_6A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 106,
    stallId: "StallClub_6B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 107,
    stallId: "StallClub_6C",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 108,
    stallId: "StallClub_6D",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 109,
    stallId: "StallClub_7A",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 110,
    stallId: "StallClub_7B",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 111,
    stallId: "StallClub_7C",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 112,
    stallId: "StallClub_7D",
    area: 36,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 113,
    stallId: "StallClub_8A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 114,
    stallId: "StallClub_8B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 115,
    stallId: "StallClub_8C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 116,
    stallId: "StallClub_8D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 117,
    stallId: "StallClub_9A",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 118,
    stallId: "StallClub_9B",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 119,
    stallId: "StallClub_9C",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
  {
    Index: 120,
    stallId: "StallClub_9D",
    area: 24,
    hallId: "JASMINE",
    Section: "The Select Club",
    section: "sectionData_9",
    zone: "J1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X4",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor6",
  },
];

const HallLotusHall_layoutData = [
  {
    Index: 121,
    stallId: "StallJIO-AA_39a",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "International Loose",
    section: "sectionData_14",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 122,
    stallId: "StallJIO-AA_39b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "International Loose",
    section: "sectionData_14",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 123,
    stallId: "StallJIO-AA_39c",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "International Loose",
    section: "sectionData_14",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 124,
    stallId: "StallJIO-AA_40a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 125,
    stallId: "StallJIO-AA_40b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 126,
    stallId: "StallJIO-AA_40c",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 127,
    stallId: "StallJIO-AB_40d",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 128,
    stallId: "StallJIO-AB_40e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 129,
    stallId: "StallJIO-AB_40f",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 130,
    stallId: "StallJIO-AB_41a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 131,
    stallId: "StallJIO-AB_41b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 132,
    stallId: "StallJIO-AB_41c",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 133,
    stallId: "StallJIO-AB_42a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 134,
    stallId: "StallJIO-AB_42b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 135,
    stallId: "StallJIO-AB_42c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 136,
    stallId: "StallJIO-AB_43a",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 137,
    stallId: "StallJIO-AC_41d",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 138,
    stallId: "StallJIO-AC_41e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 139,
    stallId: "StallJIO-AC_41f",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 140,
    stallId: "StallJIO-AC_42d",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 141,
    stallId: "StallJIO-AC_42e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 142,
    stallId: "StallJIO-AC_42f",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 143,
    stallId: "StallJIO-AC_43b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 144,
    stallId: "StallJIO-AC_43c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 145,
    stallId: "StallJIO-AC_43d",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 146,
    stallId: "StallJIO-AC_44a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 147,
    stallId: "StallJIO-AC_44b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 148,
    stallId: "StallJIO-AC_44c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 149,
    stallId: "StallJIO-AC_45a",
    area: 27,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 150,
    stallId: "StallJIO-AC_45b",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 151,
    stallId: "StallJIO-AD_43e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 152,
    stallId: "StallJIO-AD_44d",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 153,
    stallId: "StallJIO-AD_44e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 154,
    stallId: "StallJIO-AD_44f",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 155,
    stallId: "StallJIO-AD_45c",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 156,
    stallId: "StallJIO-AD_45d",
    area: 27,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 157,
    stallId: "StallJIO-AD_46a",
    area: 36,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 158,
    stallId: "StallJIO-AD_46b",
    area: 27,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 159,
    stallId: "StallJIO-AD_47a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 160,
    stallId: "StallJIO-AD_47b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 161,
    stallId: "StallJIO-AD_47c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 162,
    stallId: "StallJIO-AD_48a",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 163,
    stallId: "StallJIO-AE_46c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 164,
    stallId: "StallJIO-AE_46d",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 165,
    stallId: "StallJIO-AE_46e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 166,
    stallId: "StallJIO-AE_47d",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 167,
    stallId: "StallJIO-AE_47e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 168,
    stallId: "StallJIO-AE_47f",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 169,
    stallId: "StallJIO-AE_48b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 170,
    stallId: "StallJIO-AE_48c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 171,
    stallId: "StallJIO-AE_48d",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 172,
    stallId: "StallJIO-AE_49a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 173,
    stallId: "StallJIO-AE_49b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 174,
    stallId: "StallJIO-AE_49c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 175,
    stallId: "StallJIO-AE_50a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 176,
    stallId: "StallJIO-AE_50b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 177,
    stallId: "StallJIO-AE_50c",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 178,
    stallId: "StallJIO-AF_48e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  // {
  //   "Index": 179,
  //   "stallId": "StallJIO-AF_48f",
  //   "area": 9,
  //   "hallId": "LOTUS_HALL",
  //   "Section": "Loose Stones Colour Stones",
  //   "section": "sectionData_8",
  //   "zone": "L1",
  //   "stallDesign": "ONESIDE_OPENSTALL",
  //   "premiumType": "ONESIDE_OPENSTALL",
  //   "size": "3X3",
  //   "stallSideType": 0,
  //   "venue": "JWCC",

  //   "serviceProvider": "vendor8"
  // },
  {
    Index: 180,
    stallId: "StallJIO-AF_49d",
    area: 12,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 181,
    stallId: "StallJIO-AF_49e",
    area: 12,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 182,
    stallId: "StallJIO-AF_49f",
    area: 12,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 183,
    stallId: "StallJIO-AF_50d",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 184,
    stallId: "StallJIO-AF_50e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 185,
    stallId: "StallJIO-AF_50f",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 186,
    stallId: "StallJIO-AF_51a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 187,
    stallId: "StallJIO-AF_51b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 188,
    stallId: "StallJIO-AF_51c",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 189,
    stallId: "StallJIO-AF_52a",
    area: 12,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 190,
    stallId: "StallJIO-AF_52b",
    area: 12,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 191,
    stallId: "StallJIO-AF_52c",
    area: 12,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 192,
    stallId: "StallJIO-AG_52d",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 193,
    stallId: "StallJIO-AG_52e",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 194,
    stallId: "StallJIO-AF_53a",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 195,
    stallId: "StallJIO-AF_53b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 196,
    stallId: "StallJIO-AG_53c",
    area: 12,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 197,
    stallId: "StallJIO-AG_51d",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 198,
    stallId: "StallJIO-AG_51e",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 199,
    stallId: "StallJIO-AG_51f",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 200,
    stallId: "StallJIO-AG_54a",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 201,
    stallId: "StallJIO-AG_54b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 202,
    stallId: "StallJIO-AG_54c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 203,
    stallId: "StallJIO-AG_54d",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones(Pearls)",
    section: "sectionData_16",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 204,
    stallId: "StallJIO-AG_55a",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 205,
    stallId: "StallJIO-AG_55b",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 206,
    stallId: "StallJIO-AG_55c",
    area: 9,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
  {
    Index: 207,
    stallId: "StallJIO-AG_55d",
    area: 18,
    hallId: "LOTUS_HALL",
    Section: "Loose Stones Colour Stones",
    section: "sectionData_8",
    zone: "L1",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "JWCC",

    serviceProvider: "vendor8",
  },
];

const NESCO_layoutData = [
  {
    Index: 1,
    stallId: "Stall2H_194",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 2,
    stallId: "Stall2H_195",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 3,
    stallId: "Stall2H_196",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 4,
    stallId: "Stall2H_197",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 5,
    stallId: "Stall2H_198",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 6,
    stallId: "Stall2H_199",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 7,
    stallId: "Stall2H_200",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 8,
    stallId: "Stall2H_203",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 9,
    stallId: "Stall2H_204",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 10,
    stallId: "Stall2H_206",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 11,
    stallId: "Stall2H_207",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 12,
    stallId: "Stall2H_208",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 13,
    stallId: "Stall2H_209",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 14,
    stallId: "Stall2H_210",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 15,
    stallId: "Stall2H_211",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 16,
    stallId: "Stall2H_212",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 17,
    stallId: "Stall2H_213",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 18,
    stallId: "Stall2H_214",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 19,
    stallId: "Stall2H_215",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 20,
    stallId: "Stall2H_217",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 21,
    stallId: "Stall2H_218",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 22,
    stallId: "Stall2H_219",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 23,
    stallId: "Stall2H_220",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 24,
    stallId: "Stall2H_221",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 25,
    stallId: "Stall2H_222",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 26,
    stallId: "Stall2H_224",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 27,
    stallId: "Stall2H_225",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 28,
    stallId: "Stall2H_226",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 29,
    stallId: "Stall2H_227",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 30,
    stallId: "Stall2H_228",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 31,
    stallId: "Stall2H_230",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 32,
    stallId: "Stall2H_232",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 33,
    stallId: "Stall2H_233",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 34,
    stallId: "Stall2H_234",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 35,
    stallId: "Stall2H_235",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 36,
    stallId: "Stall2H_236",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 37,
    stallId: "Stall2H_237",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 38,
    stallId: "Stall2H_238",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 39,
    stallId: "Stall2H_239",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 40,
    stallId: "Stall2H_240",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 41,
    stallId: "Stall2H_241",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 42,
    stallId: "Stall2H_242",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 43,
    stallId: "Stall2H_245C",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 44,
    stallId: "Stall2H_245D",
    area: 12,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 45,
    stallId: "Stall2H_245E",
    area: 12,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 46,
    stallId: "Stall2H_245F",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 47,
    stallId: "Stall2H_246B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 48,
    stallId: "Stall2H_247B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 49,
    stallId: "Stall2H_248B",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 50,
    stallId: "Stall2H_248C",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 51,
    stallId: "Stall2H_248D",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 52,
    stallId: "Stall2H_248E",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 53,
    stallId: "Stall2H_249B",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 54,
    stallId: "Stall2H_249C",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 55,
    stallId: "Stall2H_251B",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 56,
    stallId: "Stall2H_252B",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 57,
    stallId: "Stall2H_253B",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 58,
    stallId: "Stall2H_253C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 59,
    stallId: "Stall2H_254C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 60,
    stallId: "Stall2H_255B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 61,
    stallId: "Stall2H_256B",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 62,
    stallId: "Stall2H_256C",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 63,
    stallId: "Stall2H_257B",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 64,
    stallId: "Stall2H_258B",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 65,
    stallId: "Stall2H_258C",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 66,
    stallId: "Stall2H_258D",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 67,
    stallId: "Stall2H_259B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 68,
    stallId: "Stall2J_243",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 69,
    stallId: "Stall2J_244",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 70,
    stallId: "Stall2J_245A",
    area: 12,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 71,
    stallId: "Stall2J_245B",
    area: 12,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 72,
    stallId: "Stall2J_245G",
    area: 12,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 73,
    stallId: "Stall2J_245H",
    area: 12,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 74,
    stallId: "Stall2J_246A",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 75,
    stallId: "Stall2J_246C",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 76,
    stallId: "Stall2J_247A",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 77,
    stallId: "Stall2J_247C",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 78,
    stallId: "Stall2J_248A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 79,
    stallId: "Stall2J_249A",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 80,
    stallId: "Stall2J_249D",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 81,
    stallId: "Stall2J_250",
    area: 72,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 82,
    stallId: "Stall2J_251A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 83,
    stallId: "Stall2J_252A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 84,
    stallId: "Stall2J_253A",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 85,
    stallId: "Stall2J_253D",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 86,
    stallId: "Stall2J_254A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 87,
    stallId: "Stall2J_254B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 88,
    stallId: "Stall2J_254D",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 89,
    stallId: "Stall2J_255A",
    area: 54,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 90,
    stallId: "Stall2J_256A",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 91,
    stallId: "Stall2J_256D",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 92,
    stallId: "Stall2J_257A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 93,
    stallId: "Stall2J_257D",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 94,
    stallId: "Stall2J_258A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 95,
    stallId: "Stall2J_259A",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 96,
    stallId: "Stall2J_259C",
    area: 27,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 97,
    stallId: "Stall2J_260B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 98,
    stallId: "Stall2J_260C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 99,
    stallId: "Stall2J_261B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 100,
    stallId: "Stall2J_261C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 101,
    stallId: "Stall2J_262B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 102,
    stallId: "Stall2J_262C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 103,
    stallId: "Stall2J_263C",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 104,
    stallId: "Stall2J_264B",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 105,
    stallId: "Stall2J_265B",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 106,
    stallId: "Stall2J_265C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 107,
    stallId: "Stall2J_265D",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 108,
    stallId: "Stall2J_268B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 109,
    stallId: "Stall2J_269B",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 110,
    stallId: "Stall2J_270B",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 111,
    stallId: "Stall2J_271B",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 112,
    stallId: "Stall2J_273B",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 113,
    stallId: "Stall2J_273C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 114,
    stallId: "Stall2J_274B",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 115,
    stallId: "Stall2J_274C",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 116,
    stallId: "Stall2J_274D",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 117,
    stallId: "Stall2J_274E",
    area: 12,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 118,
    stallId: "Stall2J_275",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 119,
    stallId: "Stall2J_276",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 120,
    stallId: "Stall2K_260A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 121,
    stallId: "Stall2K_260D",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 122,
    stallId: "Stall2K_260E",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 123,
    stallId: "Stall2K_260F",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 124,
    stallId: "Stall2K_260G",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 125,
    stallId: "Stall2K_261A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 126,
    stallId: "Stall2K_262A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 127,
    stallId: "Stall2K_263A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 128,
    stallId: "Stall2K_263B",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 129,
    stallId: "Stall2K_263D",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 130,
    stallId: "Stall2K_264A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 131,
    stallId: "Stall2K_265A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 132,
    stallId: "Stall2K_266",
    area: 72,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 133,
    stallId: "Stall2K_267",
    area: 72,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 134,
    stallId: "Stall2K_268A",
    area: 54,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 135,
    stallId: "Stall2K_269A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 136,
    stallId: "Stall2K_269D",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 137,
    stallId: "Stall2K_269E",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 138,
    stallId: "Stall2K_270A",
    area: 36,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 139,
    stallId: "Stall2K_271A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 140,
    stallId: "Stall2K_271C",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 141,
    stallId: "Stall2K_272",
    area: 72,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 142,
    stallId: "Stall2K_273A",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 143,
    stallId: "Stall2K_273D",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 144,
    stallId: "Stall2K_274A",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 145,
    stallId: "Stall2K_274F",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 146,
    stallId: "Stall2K_277",
    area: 16,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 147,
    stallId: "Stall2K_278",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 148,
    stallId: "Stall2K_280",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 149,
    stallId: "Stall2K_281",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 150,
    stallId: "Stall2K_282",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 151,
    stallId: "Stall2K_283",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 152,
    stallId: "Stall2K_284",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 153,
    stallId: "Stall2K_285",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 154,
    stallId: "Stall2K_286",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 155,
    stallId: "Stall2K_287",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 156,
    stallId: "Stall2K_288",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 157,
    stallId: "Stall2K_289",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 158,
    stallId: "Stall2K_290",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 159,
    stallId: "Stall2K_291",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 160,
    stallId: "Stall2K_292",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 161,
    stallId: "Stall2K_293",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 162,
    stallId: "Stall2K_295",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 163,
    stallId: "Stall2K_296",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 164,
    stallId: "Stall2K_297",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 165,
    stallId: "Stall2K_298",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 166,
    stallId: "Stall2K_299",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 167,
    stallId: "Stall2K_300",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 168,
    stallId: "Stall2K_301",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 169,
    stallId: "Stall2K_302",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 170,
    stallId: "Stall2K_303",
    area: 18,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 171,
    stallId: "Stall2K_305",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 172,
    stallId: "Stall2K_306",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 173,
    stallId: "Stall2K_307",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 174,
    stallId: "Stall2K_308",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 175,
    stallId: "Stall2K_309",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 176,
    stallId: "Stall2K_310",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 177,
    stallId: "Stall2K_311",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 178,
    stallId: "Stall2K_312",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 179,
    stallId: "Stall2K_313",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 180,
    stallId: "Stall2K_314",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 181,
    stallId: "Stall2K_315",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 182,
    stallId: "Stall2K_316",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 183,
    stallId: "Stall2K_317",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 184,
    stallId: "Stall2K_318",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 185,
    stallId: "Stall2K_319",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 186,
    stallId: "Stall2K_320",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 187,
    stallId: "Stall2K_321",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 188,
    stallId: "Stall2K_322",
    area: 9,
    hallId: "Hall 2 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "2A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor3",
  },
  {
    Index: 189,
    stallId: "Stall3L_323",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 190,
    stallId: "Stall3L_324",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 191,
    stallId: "Stall3L_325",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 192,
    stallId: "Stall3L_326",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 193,
    stallId: "Stall3L_327",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 194,
    stallId: "Stall3L_328",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 195,
    stallId: "Stall3L_329",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 196,
    stallId: "Stall3L_330",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 197,
    stallId: "Stall3L_331",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 198,
    stallId: "Stall3L_332",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 199,
    stallId: "Stall3L_333",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 200,
    stallId: "Stall3L_334",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 201,
    stallId: "Stall3L_335",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 202,
    stallId: "Stall3L_336",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 203,
    stallId: "Stall3L_337",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 204,
    stallId: "Stall3L_338",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 205,
    stallId: "Stall3L_339",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 206,
    stallId: "Stall3L_340",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "4X4",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 207,
    stallId: "Stall3L_341",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "4X4",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 208,
    stallId: "Stall3L_342",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 209,
    stallId: "Stall3L_343",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 210,
    stallId: "Stall3L_344",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 211,
    stallId: "Stall3L_345",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 212,
    stallId: "Stall3L_346",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 213,
    stallId: "Stall3L_347",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 214,
    stallId: "Stall3L_348",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 215,
    stallId: "Stall3L_349",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 216,
    stallId: "Stall3L_350",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 217,
    stallId: "Stall3L_351",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 218,
    stallId: "Stall3L_352",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 219,
    stallId: "Stall3L_353",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 220,
    stallId: "Stall3L_354",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 221,
    stallId: "Stall3L_355",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 222,
    stallId: "Stall3L_356",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 223,
    stallId: "Stall3L_357",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 224,
    stallId: "Stall3L_358",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 225,
    stallId: "Stall3L_359",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 226,
    stallId: "Stall3L_359A",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 227,
    stallId: "Stall3L_360",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 228,
    stallId: "Stall3L_361",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 229,
    stallId: "Stall3L_363C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 230,
    stallId: "Stall3L_363D",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 231,
    stallId: "Stall3L_363E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 232,
    stallId: "Stall3L_364C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 233,
    stallId: "Stall3L_364D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 234,
    stallId: "Stall3L_365C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 235,
    stallId: "Stall3L_365D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 236,
    stallId: "Stall3L_366B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 237,
    stallId: "Stall3L_366C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 238,
    stallId: "Stall3L_367B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 239,
    stallId: "Stall3L_367C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 240,
    stallId: "Stall3L_367D",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 241,
    stallId: "Stall3L_368B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 242,
    stallId: "Stall3L_368C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 243,
    stallId: "Stall3L_368D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 244,
    stallId: "Stall3L_368E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 245,
    stallId: "Stall3L_369B",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 246,
    stallId: "Stall3L_369C",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 247,
    stallId: "Stall3L_370B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 248,
    stallId: "Stall3L_370C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 249,
    stallId: "Stall3L_371B",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 250,
    stallId: "Stall3L_371D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 251,
    stallId: "Stall3L_371E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 252,
    stallId: "Stall3L_372B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 253,
    stallId: "Stall3L_372C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 254,
    stallId: "Stall3L_372D",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 255,
    stallId: "Stall3L_373B",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 256,
    stallId: "Stall3L_373C",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 257,
    stallId: "Stall3L_374B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 258,
    stallId: "Stall3L_374C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 259,
    stallId: "Stall3L_374D",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 260,
    stallId: "Stall3L_375",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 261,
    stallId: "Stall3L_376E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 262,
    stallId: "Stall3L_376F",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 263,
    stallId: "Stall3L_376G",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 264,
    stallId: "Stall3L_376H",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 265,
    stallId: "Stall3L_377B",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 266,
    stallId: "Stall3L_377C",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 267,
    stallId: "Stall3M_362",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 268,
    stallId: "Stall3M_363A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 269,
    stallId: "Stall3M_363B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 270,
    stallId: "Stall3M_363F",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 271,
    stallId: "Stall3M_363G",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 272,
    stallId: "Stall3M_364A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 273,
    stallId: "Stall3M_364B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 274,
    stallId: "Stall3M_364E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 275,
    stallId: "Stall3M_364F",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 276,
    stallId: "Stall3M_365A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 277,
    stallId: "Stall3M_365B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 278,
    stallId: "Stall3M_365E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 279,
    stallId: "Stall3M_366A",
    area: 54,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 280,
    stallId: "Stall3M_367A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 281,
    stallId: "Stall3M_368A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 282,
    stallId: "Stall3M_369A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 283,
    stallId: "Stall3M_370A",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 284,
    stallId: "Stall3M_370D",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 285,
    stallId: "Stall3M_371A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 286,
    stallId: "Stall3M_372A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 287,
    stallId: "Stall3M_373A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 288,
    stallId: "Stall3M_374A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 289,
    stallId: "Stall3M_376A",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 290,
    stallId: "Stall3M_376B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 291,
    stallId: "Stall3M_376D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 292,
    stallId: "Stall3M_377A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 293,
    stallId: "Stall3M_377D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 294,
    stallId: "Stall3M_377E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 295,
    stallId: "Stall3M_377F",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 296,
    stallId: "Stall3M_378B",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 297,
    stallId: "Stall3M_378C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 298,
    stallId: "Stall3M_379B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 299,
    stallId: "Stall3M_379C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 300,
    stallId: "Stall3M_380B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 301,
    stallId: "Stall3M_380C",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 302,
    stallId: "Stall3M_380D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 303,
    stallId: "Stall3M_383B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 304,
    stallId: "Stall3M_383C",
    area: 54,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 305,
    stallId: "Stall3M_384B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 306,
    stallId: "Stall3M_384C",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 307,
    stallId: "Stall3M_385",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 308,
    stallId: "Stall3N_378A",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 309,
    stallId: "Stall3N_378D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 310,
    stallId: "Stall3N_379A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 311,
    stallId: "Stall3N_379D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 312,
    stallId: "Stall3N_380A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 313,
    stallId: "Stall3N_380E",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 314,
    stallId: "Stall3N_381",
    area: 108,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "6X18",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 315,
    stallId: "Stall3N_382A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 316,
    stallId: "Stall3N_382B",
    area: 108,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X18",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 317,
    stallId: "Stall3N_383A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 318,
    stallId: "Stall3N_384A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 319,
    stallId: "Stall3N_384D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 320,
    stallId: "Stall3N_386",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 321,
    stallId: "Stall3N_387",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 322,
    stallId: "Stall3N_388",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 323,
    stallId: "Stall3N_390B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 324,
    stallId: "Stall3N_390C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 325,
    stallId: "Stall3N_391B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 326,
    stallId: "Stall3N_391C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 327,
    stallId: "Stall3N_392B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 328,
    stallId: "Stall3N_392C",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 329,
    stallId: "Stall3N_392D",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 330,
    stallId: "Stall3N_394C",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 331,
    stallId: "Stall3N_396",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 332,
    stallId: "Stall3N_397",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 333,
    stallId: "Stall3N_399B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 334,
    stallId: "Stall3N_399BC",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 335,
    stallId: "Stall3N_399C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 336,
    stallId: "Stall3N_400B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 337,
    stallId: "Stall3N_400C",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 338,
    stallId: "Stall3P_389",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 339,
    stallId: "Stall3P_390A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 340,
    stallId: "Stall3P_390D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 341,
    stallId: "Stall3P_390E",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 342,
    stallId: "Stall3P_391A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 343,
    stallId: "Stall3P_391D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 344,
    stallId: "Stall3P_391E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 345,
    stallId: "Stall3P_392A",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 346,
    stallId: "Stall3P_393",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 347,
    stallId: "Stall3P_394B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 348,
    stallId: "Stall3P_394D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 349,
    stallId: "Stall3P_395B",
    area: 72,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 350,
    stallId: "Stall3P_398A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 351,
    stallId: "Stall3P_398C",
    area: 72,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X12",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 352,
    stallId: "Stall3P_399A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 353,
    stallId: "Stall3P_399D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 354,
    stallId: "Stall3P_399E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 355,
    stallId: "Stall3P_400A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 356,
    stallId: "Stall3P_400D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 357,
    stallId: "Stall3P_400E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 358,
    stallId: "Stall3P_401B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 359,
    stallId: "Stall3P_401C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 360,
    stallId: "Stall3P_402B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 361,
    stallId: "Stall3P_402C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 362,
    stallId: "Stall3P_403B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 363,
    stallId: "Stall3P_403C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 364,
    stallId: "Stall3P_404B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 365,
    stallId: "Stall3P_404C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 366,
    stallId: "Stall3P_405B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 367,
    stallId: "Stall3P_405C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 368,
    stallId: "Stall3P_406B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 369,
    stallId: "Stall3P_406C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 370,
    stallId: "Stall3P_407C",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 371,
    stallId: "Stall3P_407D",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 372,
    stallId: "Stall3P_407E",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 373,
    stallId: "Stall3P_407F",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 374,
    stallId: "Stall3P_408B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 375,
    stallId: "Stall3P_408C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 376,
    stallId: "Stall3P_409B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 377,
    stallId: "Stall3P_409C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 378,
    stallId: "Stall3P_410B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 379,
    stallId: "Stall3P_410C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 380,
    stallId: "Stall3P_411C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 381,
    stallId: "Stall3P_412B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 382,
    stallId: "Stall3P_412C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 383,
    stallId: "Stall3P_414B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 384,
    stallId: "Stall3P_414C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 385,
    stallId: "Stall3P_415B",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 386,
    stallId: "Stall3P_415C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 387,
    stallId: "Stall3P_416",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 388,
    stallId: "Stall3P_417",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 389,
    stallId: "Stall3Q_394A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 390,
    stallId: "Stall3Q_395A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 391,
    stallId: "Stall3Q_395C",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 392,
    stallId: "Stall3Q_401A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 393,
    stallId: "Stall3Q_402A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 394,
    stallId: "Stall3Q_402D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 395,
    stallId: "Stall3Q_403A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 396,
    stallId: "Stall3Q_403D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 397,
    stallId: "Stall3Q_404A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 398,
    stallId: "Stall3Q_404D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 399,
    stallId: "Stall3Q_405A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 400,
    stallId: "Stall3Q_405D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 401,
    stallId: "Stall3Q_406A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 402,
    stallId: "Stall3Q_406D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 403,
    stallId: "Stall3Q_407B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 404,
    stallId: "Stall3Q_407A",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 405,
    stallId: "Stall3Q_407G",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 406,
    stallId: "Stall3Q_407H",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 407,
    stallId: "Stall3Q_408A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 408,
    stallId: "Stall3Q_408D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 409,
    stallId: "Stall3Q_409A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 410,
    stallId: "Stall3Q_409D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 411,
    stallId: "Stall3Q_410A",
    area: 36,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 412,
    stallId: "Stall3Q_411A",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 413,
    stallId: "Stall3Q_411B",
    area: 27,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 414,
    stallId: "Stall3Q_411D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 415,
    stallId: "Stall3Q_412A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 416,
    stallId: "Stall3Q_412D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 417,
    stallId: "Stall3Q_413",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 418,
    stallId: "Stall3Q_414A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 419,
    stallId: "Stall3Q_414D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 420,
    stallId: "Stall3Q_415A",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 421,
    stallId: "Stall3Q_415D",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 422,
    stallId: "Stall3Q_418",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 423,
    stallId: "Stall3Q_419",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 424,
    stallId: "Stall3Q_420",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 425,
    stallId: "Stall3Q_421",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 426,
    stallId: "Stall3Q_422",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 427,
    stallId: "Stall3Q_423",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 428,
    stallId: "Stall3Q_424",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 429,
    stallId: "Stall3Q_425",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 430,
    stallId: "Stall3Q_426",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 431,
    stallId: "Stall3Q_427",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 432,
    stallId: "Stall3Q_428",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 433,
    stallId: "Stall3Q_429",
    area: 12,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 434,
    stallId: "Stall3Q_430",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 435,
    stallId: "Stall3Q_431A",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 436,
    stallId: "Stall3Q_431B",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 437,
    stallId: "Stall3Q_431C",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 438,
    stallId: "Stall3Q_432",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 439,
    stallId: "Stall3Q_433",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 440,
    stallId: "Stall3Q_434",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 441,
    stallId: "Stall3Q_435",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 442,
    stallId: "Stall3Q_436",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 443,
    stallId: "Stall3Q_437",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 444,
    stallId: "Stall3Q_438",
    area: 16,
    hallId: "Hall 3 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 445,
    stallId: "Stall3Q_439",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 446,
    stallId: "Stall3Q_440",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 447,
    stallId: "Stall3Q_441",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 448,
    stallId: "Stall3Q_442",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 449,
    stallId: "Stall3Q_443",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 450,
    stallId: "Stall3Q_445",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 451,
    stallId: "Stall3Q_446",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 452,
    stallId: "Stall3Q_447",
    area: 9,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 453,
    stallId: "Stall3Q_448",
    area: 18,
    hallId: "Hall 3 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "3A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 454,
    stallId: "Stall4R_451",
    area: 108,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 455,
    stallId: "Stall4R_452A",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 456,
    stallId: "Stall4R_452B",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 457,
    stallId: "Stall4R_453A",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 458,
    stallId: "Stall4R_453B",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 459,
    stallId: "Stall4R_454A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 460,
    stallId: "Stall4R_454B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 461,
    stallId: "Stall4R_454C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 462,
    stallId: "Stall4R_454D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 463,
    stallId: "Stall4R_455A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 464,
    stallId: "Stall4R_455B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 465,
    stallId: "Stall4R_456",
    area: 108,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 466,
    stallId: "Stall4R_457A",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 467,
    stallId: "Stall4R_457B",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 468,
    stallId: "Stall4R_458A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 469,
    stallId: "Stall4R_458B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 470,
    stallId: "Stall4R_458C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 471,
    stallId: "Stall4R_458D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 472,
    stallId: "Stall4R_459A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 473,
    stallId: "Stall4R_459B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 474,
    stallId: "Stall4R_460A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 475,
    stallId: "Stall4R_460B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 476,
    stallId: "Stall4R_461A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 477,
    stallId: "Stall4R_461B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 478,
    stallId: "Stall4R_461C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 479,
    stallId: "Stall4R_462A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 480,
    stallId: "Stall4R_462B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 481,
    stallId: "Stall4R_462C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 482,
    stallId: "Stall4R_463A",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 483,
    stallId: "Stall4R_463B",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 484,
    stallId: "Stall4R_463C",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 485,
    stallId: "Stall4R_463D",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 486,
    stallId: "Stall4R_463E",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 487,
    stallId: "Stall4R_463F",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 488,
    stallId: "Stall4R_464",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 489,
    stallId: "Stall4R_465",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 490,
    stallId: "Stall4R_466",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 491,
    stallId: "Stall4R_467",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 492,
    stallId: "Stall4R_468",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 493,
    stallId: "Stall4R_469C",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 494,
    stallId: "Stall4R_470B",
    area: 16,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 495,
    stallId: "Stall4R_470C",
    area: 16,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 496,
    stallId: "Stall4R_470D",
    area: 16,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 497,
    stallId: "Stall4R_470E",
    area: 16,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 498,
    stallId: "Stall4R_471B",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 499,
    stallId: "Stall4R_471C",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 500,
    stallId: "Stall4R_471D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 501,
    stallId: "Stall4R_472C",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 502,
    stallId: "Stall4R_472D",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 503,
    stallId: "Stall4R_472E",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 504,
    stallId: "Stall4R_472F",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 505,
    stallId: "Stall4R_473B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 506,
    stallId: "Stall4R_473C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 507,
    stallId: "Stall4R_473D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 508,
    stallId: "Stall4R_474B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 509,
    stallId: "Stall4R_474C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 510,
    stallId: "Stall4R_474D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 511,
    stallId: "Stall4R_475B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 512,
    stallId: "Stall4R_475C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 513,
    stallId: "Stall4R_476B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 514,
    stallId: "Stall4R_476C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 515,
    stallId: "Stall4R_478B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 516,
    stallId: "Stall4R_478C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 517,
    stallId: "Stall4R_479B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 518,
    stallId: "Stall4R_479C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 519,
    stallId: "Stall4R_480B",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 520,
    stallId: "Stall4R_481B",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 521,
    stallId: "Stall4R_481C",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 522,
    stallId: "Stall4R_481D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 523,
    stallId: "Stall4R_481E",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 524,
    stallId: "Stall4R_481F",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 525,
    stallId: "Stall4S_469A",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 526,
    stallId: "Stall4S_469B",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 527,
    stallId: "Stall4S_470A",
    area: 16,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 528,
    stallId: "Stall4S_470F",
    area: 16,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X4",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 529,
    stallId: "Stall4S_471A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 530,
    stallId: "Stall4S_471E",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 531,
    stallId: "Stall4S_472A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 532,
    stallId: "Stall4S_472B",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 533,
    stallId: "Stall4S_472G",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 534,
    stallId: "Stall4S_473A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 535,
    stallId: "Stall4S_474A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 536,
    stallId: "Stall4S_475A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 537,
    stallId: "Stall4S_475D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 538,
    stallId: "Stall4S_476A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 539,
    stallId: "Stall4S_476D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 540,
    stallId: "Stall4S_477A",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 541,
    stallId: "Stall4S_477B",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 542,
    stallId: "Stall4S_478A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 543,
    stallId: "Stall4S_478D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 544,
    stallId: "Stall4S_479A",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 545,
    stallId: "Stall4S_480A",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 546,
    stallId: "Stall4S_481A",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 547,
    stallId: "Stall4S_482B",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 548,
    stallId: "Stall4S_483B",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 549,
    stallId: "Stall4S_484A",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 550,
    stallId: "Stall4S_484B",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 551,
    stallId: "Stall4S_485B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 552,
    stallId: "Stall4S_485C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 553,
    stallId: "Stall4S_486B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 554,
    stallId: "Stall4S_486C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 555,
    stallId: "Stall4S_487B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 556,
    stallId: "Stall4S_487C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 557,
    stallId: "Stall4S_488B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 558,
    stallId: "Stall4S_488C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 559,
    stallId: "Stall4S_489B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 560,
    stallId: "Stall4S_489C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 561,
    stallId: "Stall4S_489D",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 562,
    stallId: "Stall4S_490B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 563,
    stallId: "Stall4S_490C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 564,
    stallId: "Stall4S_490D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 565,
    stallId: "Stall4S_491B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 566,
    stallId: "Stall4S_491C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 567,
    stallId: "Stall4S_491D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 568,
    stallId: "Stall4S_492B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 569,
    stallId: "Stall4S_492C",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 570,
    stallId: "Stall4S_492D",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 571,
    stallId: "Stall4S_493C",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 572,
    stallId: "Stall4S_493D",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 573,
    stallId: "Stall4S_493E",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 574,
    stallId: "Stall4S_493F",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 575,
    stallId: "Stall4S_494A",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 576,
    stallId: "Stall4S_494B",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor8",
  },
  {
    Index: 577,
    stallId: "Stall4S_495",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 578,
    stallId: "Stall4T_482A",
    area: 72,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 579,
    stallId: "Stall4T_483A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 580,
    stallId: "Stall4T_483C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 581,
    stallId: "Stall4T_485A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 582,
    stallId: "Stall4T_485D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 583,
    stallId: "Stall4T_486A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 584,
    stallId: "Stall4T_486D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 585,
    stallId: "Stall4T_487A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 586,
    stallId: "Stall4T_487D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 587,
    stallId: "Stall4T_488A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 588,
    stallId: "Stall4T_488D",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 589,
    stallId: "Stall4T_489A",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 590,
    stallId: "Stall4T_489E",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 591,
    stallId: "Stall4T_490A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 592,
    stallId: "Stall4T_491A",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 593,
    stallId: "Stall4T_491E",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 594,
    stallId: "Stall4T_492A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 595,
    stallId: "Stall4T_492E",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 596,
    stallId: "Stall4T_493A",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 597,
    stallId: "Stall4T_493B",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 598,
    stallId: "Stall4T_493G",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 599,
    stallId: "Stall4T_493H",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 600,
    stallId: "Stall4T_496",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 601,
    stallId: "Stall4T_497",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 602,
    stallId: "Stall4T_498",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 603,
    stallId: "Stall4T_499A",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 604,
    stallId: "Stall4T_499B",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 605,
    stallId: "Stall4T_500A",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 606,
    stallId: "Stall4T_500B",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 607,
    stallId: "Stall4T_500C",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 608,
    stallId: "Stall4T_500D",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 609,
    stallId: "Stall4T_500E",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 610,
    stallId: "Stall4T_500F",
    area: 12,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 611,
    stallId: "Stall4T_501A",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 612,
    stallId: "Stall4T_501B",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 613,
    stallId: "Stall4T_501C",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 614,
    stallId: "Stall4T_501D",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 615,
    stallId: "Stall4T_501E",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 616,
    stallId: "Stall4T_501F",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 617,
    stallId: "Stall4T_502A",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 618,
    stallId: "Stall4T_502B",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 619,
    stallId: "Stall4T_502C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 620,
    stallId: "Stall4T_502D",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 621,
    stallId: "Stall4T_502E",
    area: 9,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 622,
    stallId: "Stall4T_503A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 623,
    stallId: "Stall4T_503B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 624,
    stallId: "Stall4T_504A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 625,
    stallId: "Stall4T_504B",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 626,
    stallId: "Stall4T_505A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 627,
    stallId: "Stall4T_505B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 628,
    stallId: "Stall4T_505C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 629,
    stallId: "Stall4T_505D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 630,
    stallId: "Stall4T_506A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 631,
    stallId: "Stall4T_506B",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 632,
    stallId: "Stall4T_506C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 633,
    stallId: "Stall4T_507A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 634,
    stallId: "Stall4T_507B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 635,
    stallId: "Stall4T_507C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 636,
    stallId: "Stall4T_507D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 637,
    stallId: "Stall4T_508",
    area: 108,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 638,
    stallId: "Stall4T_509A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 639,
    stallId: "Stall4T_509B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 640,
    stallId: "Stall4T_510",
    area: 108,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 641,
    stallId: "Stall4T_511A",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 642,
    stallId: "Stall4T_511B",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 643,
    stallId: "Stall4T_511C",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 644,
    stallId: "Stall4T_511D",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 645,
    stallId: "Stall4T_512A",
    area: 36,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X6",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 646,
    stallId: "Stall4T_512B",
    area: 54,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 647,
    stallId: "Stall4T_512C",
    area: 18,
    hallId: "Hall 4 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "4A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 648,
    stallId: "Stall6A_001",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 649,
    stallId: "Stall6A_002",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 650,
    stallId: "Stall6A_003",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 651,
    stallId: "Stall6A_004",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 652,
    stallId: "Stall6A_005",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 653,
    stallId: "Stall6A_006",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 654,
    stallId: "Stall6A_007",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 655,
    stallId: "Stall6A_008",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 656,
    stallId: "Stall6A_009",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 657,
    stallId: "Stall6A_010",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 658,
    stallId: "Stall6A_011",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 659,
    stallId: "Stall6A_012",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 660,
    stallId: "Stall6A_013A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 661,
    stallId: "Stall6A_013B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 662,
    stallId: "Stall6A_014",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 663,
    stallId: "Stall6A_015B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 664,
    stallId: "Stall6A_015C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 665,
    stallId: "Stall6A_015D",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 666,
    stallId: "Stall6A_015E",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 667,
    stallId: "Stall6A_016B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 668,
    stallId: "Stall6A_016C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 669,
    stallId: "Stall6A_017B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 670,
    stallId: "Stall6A_017C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 671,
    stallId: "Stall6B_017D",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 672,
    stallId: "Stall6A_018B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 673,
    stallId: "Stall6A_019B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 674,
    stallId: "Stall6A_019C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 675,
    stallId: "Stall6B_015A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 676,
    stallId: "Stall6B_015F",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 677,
    stallId: "Stall6B_015G",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 678,
    stallId: "Stall6B_016A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 679,
    stallId: "Stall6B_017A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 680,
    stallId: "Stall6B_017D",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 681,
    stallId: "Stall6B_018A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 682,
    stallId: "Stall6B_018C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 683,
    stallId: "Stall6B_019A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 684,
    stallId: "Stall6B_019D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 685,
    stallId: "Stall6B_019E",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 686,
    stallId: "Stall6B_020C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 687,
    stallId: "Stall6B_022B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 688,
    stallId: "Stall6B_022C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 689,
    stallId: "Stall6B_024B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 690,
    stallId: "Stall6B_024C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 691,
    stallId: "Stall6B_025",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 692,
    stallId: "Stall6C_020A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 693,
    stallId: "Stall6C_020D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 694,
    stallId: "Stall6C_021A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 695,
    stallId: "Stall6C_021B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 696,
    stallId: "Stall6C_022A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 697,
    stallId: "Stall6C_022D",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 698,
    stallId: "Stall6C_023A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 699,
    stallId: "Stall6B_023B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 700,
    stallId: "Stall6C_023C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 701,
    stallId: "Stall6C_024A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 702,
    stallId: "Stall6C_026",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 703,
    stallId: "Stall6C_027B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 704,
    stallId: "Stall6C_027C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 705,
    stallId: "Stall6C_028B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 706,
    stallId: "Stall6C_029B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 707,
    stallId: "Stall6C_029C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 708,
    stallId: "Stall6D_027A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 709,
    stallId: "Stall6D_028A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 710,
    stallId: "Stall6D_028C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 711,
    stallId: "Stall6D_029A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 712,
    stallId: "Stall6D_029D",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 713,
    stallId: "Stall6D_030A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 714,
    stallId: "Stall6D_030B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 715,
    stallId: "Stall6D_031",
    area: 72,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 716,
    stallId: "Stall6D_035B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 717,
    stallId: "Stall6D_036B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 718,
    stallId: "Stall6D_036C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 719,
    stallId: "Stall6D_037",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 720,
    stallId: "Stall6E_032",
    area: 72,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 721,
    stallId: "Stall6E_033A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 722,
    stallId: "Stall6E_033B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 723,
    stallId: "Stall6E_034A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 724,
    stallId: "Stall6E_034B",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 725,
    stallId: "Stall6E_035A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 726,
    stallId: "Stall6E_035C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 727,
    stallId: "Stall6E_036A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 728,
    stallId: "Stall6E_038",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 729,
    stallId: "Stall6E_039",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 730,
    stallId: "Stall6E_040B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 731,
    stallId: "Stall6E_040C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 732,
    stallId: "Stall6F_040A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 733,
    stallId: "Stall6F_041A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 734,
    stallId: "Stall6F_041B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 735,
    stallId: "Stall6F_042A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 736,
    stallId: "Stall6F_042B",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 737,
    stallId: "Stall6F_043A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 738,
    stallId: "Stall6F_043B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 739,
    stallId: "Stall6F_044A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 740,
    stallId: "Stall6F_049B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 741,
    stallId: "Stall6F_049C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 742,
    stallId: "Stall6F_050",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 743,
    stallId: "Stall6F_051",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 744,
    stallId: "Stall6F_052",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 745,
    stallId: "Stall6G_045A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 746,
    stallId: "Stall6G_045B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 747,
    stallId: "Stall6G_046A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 748,
    stallId: "Stall6G_046B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 749,
    stallId: "Stall6G_047A",
    area: 72,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 750,
    stallId: "Stall6G_047B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 751,
    stallId: "Stall6G_048A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 752,
    stallId: "Stall6G_048B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 753,
    stallId: "Stall6G_049A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 754,
    stallId: "Stall6H_053",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 755,
    stallId: "Stall6H_054",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 756,
    stallId: "Stall6H_055",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 757,
    stallId: "Stall6H_056",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 758,
    stallId: "Stall6H_057",
    area: 108,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12x9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 759,
    stallId: "Stall6H_058",
    area: 108,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12x9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 760,
    stallId: "Stall6H_059",
    area: 108,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12x9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 761,
    stallId: "Stall6H_060",
    area: 108,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12x9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 762,
    stallId: "Stall6H_065",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 763,
    stallId: "Stall6J_061",
    area: 108,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12x9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 764,
    stallId: "Stall6J_062",
    area: 108,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12x9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 765,
    stallId: "Stall6J_063",
    area: 108,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12x9",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 766,
    stallId: "Stall6J_064A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 767,
    stallId: "Stall6J_064B",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 768,
    stallId: "Stall6J_067",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 769,
    stallId: "Stall6J_069B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 770,
    stallId: "Stall6J_069C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 771,
    stallId: "Stall6K_069A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 772,
    stallId: "Stall6K_069D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 773,
    stallId: "Stall6K_070A",
    area: 72,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "FOURSIDE_OPENSTALL",
    premiumType: "FOURSIDE_OPENSTALL",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 774,
    stallId: "Stall6K_071A",
    area: 72,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "12X6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 775,
    stallId: "Stall6K_071B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "PREMIUM",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 776,
    stallId: "Stall6K_072A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 777,
    stallId: "Stall6K_072B",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 778,
    stallId: "Stall6K_073A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 779,
    stallId: "Stall6K_073B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 780,
    stallId: "Stall6K_075B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 781,
    stallId: "Stall6K_075C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 782,
    stallId: "Stall6K_075D",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 783,
    stallId: "Stall6K_075E",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 784,
    stallId: "Stall6K_076B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 785,
    stallId: "Stall6K_078B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 786,
    stallId: "Stall6K_078C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 787,
    stallId: "Stall6K_079",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 788,
    stallId: "Stall6L_074A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 789,
    stallId: "Stall6L_074B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 790,
    stallId: "Stall6L_075A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 791,
    stallId: "Stall6L_075F",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 792,
    stallId: "Stall6L_075G",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 793,
    stallId: "Stall6L_075H",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 794,
    stallId: "Stall6L_076A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 795,
    stallId: "Stall6L_076C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 796,
    stallId: "Stall6L_077A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 797,
    stallId: "Stall6L_077B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 798,
    stallId: "Stall6L_078A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 799,
    stallId: "Stall6L_078D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 800,
    stallId: "Stall6L_082",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 801,
    stallId: "Stall6L_086B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 802,
    stallId: "Stall6L_086C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 803,
    stallId: "Stall6L_088B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 804,
    stallId: "Stall6L_088C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 805,
    stallId: "Stall6L_089B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 806,
    stallId: "Stall6L_089C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Laboratory and Education",
    section: "sectionData_4",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 807,
    stallId: "Stall6M_086A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 808,
    stallId: "Stall6M_086E",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 809,
    stallId: "Stall6M_087A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 810,
    stallId: "Stall6M_087B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 811,
    stallId: "Stall6M_088A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 812,
    stallId: "Stall6M_088D",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 813,
    stallId: "Stall6M_089A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 814,
    stallId: "Stall6M_089D",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 815,
    stallId: "Stall6M_090A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 816,
    stallId: "Stall6M_090B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 817,
    stallId: "Stall6M_093B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 818,
    stallId: "Stall6M_093C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 819,
    stallId: "Stall6M_095B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 820,
    stallId: "Stall6M_095C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 821,
    stallId: "Stall6N_091A",
    area: 54,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "9x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 822,
    stallId: "Stall6N_091B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 823,
    stallId: "Stall6N_092A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 824,
    stallId: "Stall6N_092B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 825,
    stallId: "Stall6N_093A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 826,
    stallId: "Stall6N_093D",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 827,
    stallId: "Stall6N_094A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 828,
    stallId: "Stall6N_094B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 829,
    stallId: "Stall6N_095A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 830,
    stallId: "Stall6N_095D",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 831,
    stallId: "Stall6N_096B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 832,
    stallId: "Stall6N_096C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 833,
    stallId: "Stall6N_097B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 834,
    stallId: "Stall6N_097C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 835,
    stallId: "Stall6N_098B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 836,
    stallId: "Stall6N_098C",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 837,
    stallId: "Stall6P_096A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 838,
    stallId: "Stall6P_096D",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 839,
    stallId: "Stall6P_096E",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 840,
    stallId: "Stall6P_097A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 841,
    stallId: "Stall6P_097D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 842,
    stallId: "Stall6P_098A",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 843,
    stallId: "Stall6P_098D",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 844,
    stallId: "Stall6P_099A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 845,
    stallId: "Stall6P_099B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 846,
    stallId: "Stall6P_100A",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 847,
    stallId: "Stall6P_100B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 848,
    stallId: "Stall6P_101B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 849,
    stallId: "Stall6P_101C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 850,
    stallId: "Stall6P_102B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 851,
    stallId: "Stall6P_102C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 852,
    stallId: "Stall6P_103B",
    area: 27,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "9X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 853,
    stallId: "Stall6P_103C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 854,
    stallId: "Stall6P_103D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 855,
    stallId: "Stall6P_104B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 856,
    stallId: "Stall6P_104C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 857,
    stallId: "Stall6P_105B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 858,
    stallId: "Stall6P_105C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 859,
    stallId: "Stall6P_105D",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 860,
    stallId: "Stall6Q_101A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 861,
    stallId: "Stall6Q_101D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 862,
    stallId: "Stall6Q_102A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 863,
    stallId: "Stall6Q_102D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 864,
    stallId: "Stall6Q_103A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 865,
    stallId: "Stall6Q_103E",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 866,
    stallId: "Stall6Q_103F",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 867,
    stallId: "Stall6Q_103G",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 868,
    stallId: "Stall6Q_104A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 869,
    stallId: "Stall6Q_104D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 870,
    stallId: "Stall6Q_105A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 871,
    stallId: "Stall6Q_105E",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 872,
    stallId: "Stall6Q_105F",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 873,
    stallId: "Stall6Q_106",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 874,
    stallId: "Stall6Q_107",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 875,
    stallId: "Stall6Q_108",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 876,
    stallId: "Stall6Q_109",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 877,
    stallId: "Stall6Q_110",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 878,
    stallId: "Stall6Q_111",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 879,
    stallId: "Stall6Q_114",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 880,
    stallId: "Stall6Q_115",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 881,
    stallId: "Stall6Q_116",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 882,
    stallId: "Stall6Q_117",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 883,
    stallId: "Stall6Q_118",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 884,
    stallId: "Stall6Q_119",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 885,
    stallId: "Stall6Q_120",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 886,
    stallId: "Stall6Q_121",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 887,
    stallId: "Stall6Q_122",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 888,
    stallId: "Stall6Q_123",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 889,
    stallId: "Stall6Q_124A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 917,
    stallId: "Stall6Q_124B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Diamond, Gemstone, and Other Studded Jewellery",
    section: "sectionData_1",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 890,
    stallId: "Stall6R_125A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 891,
    stallId: "Stall6R_125B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 892,
    stallId: "Stall6R_126A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 893,
    stallId: "Stall6R_126B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 894,
    stallId: "Stall6R_126C",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 895,
    stallId: "Stall6R_126D",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 896,
    stallId: "Stall6R_126G",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 897,
    stallId: "Stall6R_127A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 898,
    stallId: "Stall6R_127B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 899,
    stallId: "Stall6R_127C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 900,
    stallId: "Stall6R_128A",
    area: 12,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 901,
    stallId: "Stall6R_128B",
    area: 12,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 902,
    stallId: "Stall6R_128C",
    area: 12,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 903,
    stallId: "Stall6R_128D",
    area: 12,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 904,
    stallId: "Stall6R_129A",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 905,
    stallId: "Stall6R_129B",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 906,
    stallId: "Stall6R_129E",
    area: 12,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 907,
    stallId: "Stall6R_129F",
    area: 12,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "4X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 908,
    stallId: "Stall6R_130A",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6C",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 909,
    stallId: "Stall6R_130B",
    area: 9,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6C",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "3X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 912,
    stallId: "Stall6A_038",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 913,
    stallId: "Stall6A_037",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "ONESIDE_OPENSTALL",
    premiumType: "ONESIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 914,
    stallId: "Stall6C_020C",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 1,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 915,
    stallId: "Stall6B_020D",
    area: 18,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6A",
    stallDesign: "TWOSIDE_OPENSTALL",
    premiumType: "TWOSIDE_OPENSTALL",
    size: "6X3",
    stallSideType: 2,
    venue: "BEC",
    serviceProvider: "vendor2",
  },
  {
    Index: 916,
    stallId: "Stall6F_044B",
    area: 36,
    hallId: "HALL 6 - BEC",
    Section: "Gold and Gold CZ Studded Jewellery",
    section: "sectionData_2",
    zone: "6B",
    stallDesign: "THREESIDE_OPENSTALL",
    premiumType: "THREESIDE_OPENSTALL",
    size: "6x6",
    stallSideType: 0,
    venue: "BEC",
    serviceProvider: "vendor2",
  },

  {
    "Index": 920,
    "stallId": "Stall5U_516",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 921,
    "stallId": "Stall5U_517",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 922,
    "stallId": "Stall5U_518",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 923,
    "stallId": "Stall5U_519",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 924,
    "stallId": "Stall5U_520",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 925,
    "stallId": "Stall5U_521",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 926,
    "stallId": "Stall5U_522",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 928,
    "stallId": "Stall5U_524",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 929,
    "stallId": "Stall5U_525",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 930,
    "stallId": "Stall5U_526",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 931,
    "stallId": "Stall5U_527",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 932,
    "stallId": "Stall5U_528",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 933,
    "stallId": "Stall5U_529",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 934,
    "stallId": "Stall5U_530",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 935,
    "stallId": "Stall5U_531",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 936,
    "stallId": "Stall5U_532",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 937,
    "stallId": "Stall5U_533",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 938,
    "stallId": "Stall5U_534",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 939,
    "stallId": "Stall5U_535",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 940,
    "stallId": "Stall5U_536",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 941,
    "stallId": "Stall5U_537",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 942,
    "stallId": "Stall5U_538",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 943,
    "stallId": "Stall5U_539",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 944,
    "stallId": "Stall5U_540",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 945,
    "stallId": "Stall5U_541",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 946,
    "stallId": "Stall5U_542",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 947,
    "stallId": "Stall5U_543",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 948,
    "stallId": "Stall5U_544",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 949,
    "stallId": "Stall5U_545",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 950,
    "stallId": "Stall5U_546",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 951,
    "stallId": "Stall5U_547",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 952,
    "stallId": "Stall5U_548",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 953,
    "stallId": "Stall5U_549",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 954,
    "stallId": "Stall5U_550",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 955,
    "stallId": "Stall5U_551",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 956,
    "stallId": "Stall5U_552",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 957,
    "stallId": "Stall5U_553",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 958,
    "stallId": "Stall5U_554",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 959,
    "stallId": "Stall5V_558A",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 960,
    "stallId": "Stall5U_558B",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 961,
    "stallId": "Stall5U_558C",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 962,
    "stallId": "Stall5U_558D",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 963,
    "stallId": "Stall5U_558E",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 964,
    "stallId": "Stall5V_558F",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 965,
    "stallId": "Stall5V_559A",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 966,
    "stallId": "Stall5U_559B",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 967,
    "stallId": "Stall5U_559C",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 968,
    "stallId": "Stall5U_559D",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 969,
    "stallId": "Stall5U_559E",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 970,
    "stallId": "Stall5V_559F",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 971,
    "stallId": "Stall5V_560A",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 972,
    "stallId": "Stall5V_560B",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 973,
    "stallId": "Stall5U_560C",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 974,
    "stallId": "Stall5U_560D",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 975,
    "stallId": "Stall5U_560E",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  // {
  //   "Index": 976,
  //   "stallId": "Stall5U_560F",
  //   "area": 9,
  //   "hallId": "HALL 5 - BEC",
  //   "Section": "Machinery",
  //   "section": "sectionData_12",
  //   "zone": "5A",
  //   "stallDesign": "ONESIDE_OPENSTALL",
  //   "premiumType": "ONESIDE_OPENSTALL",
  //   "size": "3X3",
  //   "stallSideType": 0,
  //   "venue": "BEC",
  //   "serviceProvider": "vendor8"
  // },
  {
    "Index": 977,
    "stallId": "Stall5V_560G",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 978,
    "stallId": "Stall5V_561A",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 979,
    "stallId": "Stall5U_561B",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 980,
    "stallId": "Stall5U_561C",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 981,
    "stallId": "Stall5V_561D",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 982,
    "stallId": "Stall5V_562A",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 983,
    "stallId": "Stall5U_562B",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 984,
    "stallId": "Stall5U_562C",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 985,
    "stallId": "Stall5V_562D",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 986,
    "stallId": "Stall5V_563A",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 987,
    "stallId": "Stall5U_563B",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 988,
    "stallId": "Stall5U_563C",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 989,
    "stallId": "Stall5V_563D",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 990,
    "stallId": "Stall5V_564A",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 991,
    "stallId": "Stall5U_564B",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 992,
    "stallId": "Stall5U_564C",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 993,
    "stallId": "Stall5V_564D",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 994,
    "stallId": "Stall5V_565A",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 995,
    "stallId": "Stall5V_565B",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 996,
    "stallId": "Stall5U_565C",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 997,
    "stallId": "Stall5U_565D",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 998,
    "stallId": "Stall5V_565E",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 999,
    "stallId": "Stall5V_566A",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1000,
    "stallId": "Stall5U_566B",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1001,
    "stallId": "Stall5U_566C",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1002,
    "stallId": "Stall5V_566D",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1003,
    "stallId": "Stall5V_567A",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1004,
    "stallId": "Stall5V_567B",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1005,
    "stallId": "Stall5U_567C",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1006,
    "stallId": "Stall5U_567D",
    "area": 27,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1008,
    "stallId": "Stall5V_568A",
    "area": 27,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1009,
    "stallId": "Stall5V_568B",
    "area": 27,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1010,
    "stallId": "Stall5V_569A",
    "area": 27,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1011,
    "stallId": "Stall5V_569B",
    "area": 27,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1012,
    "stallId": "Stall5V_570",
    "area": 36,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1013,
    "stallId": "Stall5V_571A",
    "area": 72,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1014,
    "stallId": "Stall5V_571B",
    "area": 72,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1015,
    "stallId": "Stall5V_575",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "INTERNATIONAL MACHINERY",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1016,
    "stallId": "Stall5V_576",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "INTERNATIONAL MACHINERY",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1017,
    "stallId": "Stall5V_577",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "INTERNATIONAL MACHINERY",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1018,
    "stallId": "Stall5V_578",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "INTERNATIONAL MACHINERY",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1019,
    "stallId": "Stall5V_579",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "INTERNATIONAL MACHINERY",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1020,
    "stallId": "Stall5V_580",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "INTERNATIONAL MACHINERY",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1021,
    "stallId": "Stall5V_581",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1022,
    "stallId": "Stall5V_582",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1023,
    "stallId": "Stall5V_583",
    "area": 18,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1024,
    "stallId": "Stall5V_584",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1025,
    "stallId": "Stall5V_585",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1026,
    "stallId": "Stall5V_586",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1027,
    "stallId": "Stall5V_587",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1028,
    "stallId": "Stall5V_588",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1029,
    "stallId": "Stall5V_589",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1030,
    "stallId": "Stall5V_590",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1031,
    "stallId": "Stall5V_591",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1032,
    "stallId": "Stall5V_592",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1033,
    "stallId": "Stall5V_593",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1034,
    "stallId": "Stall5V_594",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1035,
    "stallId": "Stall5V_595",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1036,
    "stallId": "Stall5V_596",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1037,
    "stallId": "Stall5V_597",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1038,
    "stallId": "Stall5V_598",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1039,
    "stallId": "Stall5V_599",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1040,
    "stallId": "Stall5V_600",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1041,
    "stallId": "Stall5V_601",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1042,
    "stallId": "Stall5V_602",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1043,
    "stallId": "Stall5V_603",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1044,
    "stallId": "Stall5V_604",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1045,
    "stallId": "Stall5V_605",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1046,
    "stallId": "Stall5V_606",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1047,
    "stallId": "Stall5V_607",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1048,
    "stallId": "Stall5V_608",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1049,
    "stallId": "Stall5V_609",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1051,
    "stallId": "StallAU_001",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1052,
    "stallId": "StallAU_002",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1053,
    "stallId": "StallAU_004",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1054,
    "stallId": "StallAU_005",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1055,
    "stallId": "StallAU_006",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1056,
    "stallId": "StallAU_007",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1057,
    "stallId": "StallAU_008",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1058,
    "stallId": "StallAU_009",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1059,
    "stallId": "StallAU_010",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1060,
    "stallId": "StallAU_011",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1061,
    "stallId": "StallAU_012",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1062,
    "stallId": "StallAU_013",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1063,
    "stallId": "StallAU_014",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1064,
    "stallId": "StallAU_015",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1065,
    "stallId": "StallAU_016",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1066,
    "stallId": "StallAU_017",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1067,
    "stallId": "StallAU_018",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1068,
    "stallId": "StallAU_019A",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1069,
    "stallId": "StallAU_019B",
    "area": 54,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1070,
    "stallId": "StallAU_019C",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1071,
    "stallId": "StallAU_020A",
    "area": 54,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1072,
    "stallId": "StallAU_020B",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1073,
    "stallId": "StallAU_020C",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1074,
    "stallId": "StallAU_020D",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1075,
    "stallId": "StallAU_020E",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1076,
    "stallId": "StallAU_020F",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1077,
    "stallId": "StallAU_020G",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1078,
    "stallId": "StallAU_020H",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1079,
    "stallId": "StallAU_020J",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1080,
    "stallId": "StallAU_021A",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "International_Allied",
    "section": "sectionData_17",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1081,
    "stallId": "StallAU_021B",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "International_Allied",
    "section": "sectionData_17",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1082,
    "stallId": "StallAU_022",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1083,
    "stallId": "StallAU_023A",
    "area": 72,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1084,
    "stallId": "StallAU_023B",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1085,
    "stallId": "StallAU_023C",
    "area": 27,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1086,
    "stallId": "StallAU_023D",
    "area": 27,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1087,
    "stallId": "StallAU_023E",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1088,
    "stallId": "StallAU_024A",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1089,
    "stallId": "StallAU_024B",
    "area": 27,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1090,
    "stallId": "StallAU_024C",
    "area": 27,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1091,
    "stallId": "StallAU_024D",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1092,
    "stallId": "StallAU_025",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1093,
    "stallId": "StallAU_026",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1094,
    "stallId": "StallAU_027",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1095,
    "stallId": "StallAU_028",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1096,
    "stallId": "StallAU_029",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1097,
    "stallId": "StallAU_030",
    "area": 18,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1098,
    "stallId": "StallAU_031",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1099,
    "stallId": "StallAU_032",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1100,
    "stallId": "StallAU_033",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1101,
    "stallId": "StallAU_034",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1102,
    "stallId": "StallAU_035",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1103,
    "stallId": "StallAU_036",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1104,
    "stallId": "StallAU_037",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1105,
    "stallId": "StallAU_038",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1106,
    "stallId": "StallAU_039",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1107,
    "stallId": "StallAU_045",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1108,
    "stallId": "StallAU_046",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1109,
    "stallId": "StallAU_047",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1110,
    "stallId": "StallAU_048",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1111,
    "stallId": "StallAU_049",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1112,
    "stallId": "StallAU_050",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1113,
    "stallId": "StallAU_051",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1114,
    "stallId": "StallAU_052",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1115,
    "stallId": "StallAU_053",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1116,
    "stallId": "StallAU_054",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1117,
    "stallId": "StallAU_055",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1118,
    "stallId": "StallAU_056",
    "area": 9,
    "hallId": "AURUM_",
    "Section": "Allied",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1119,
    "stallId": "Stall5V_557A",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1120,
    "stallId": "Stall5U_557B",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1121,
    "stallId": "Stall5U_557C",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "Machinery",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "Index": 1122,
    "stallId": "Stall5V_575A",
    "area": 9,
    "hallId": "HALL 5 - BEC",
    "Section": "INTERNATIONAL MACHINERY",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  }
];

// Split combined NESCO layout by hall so each hall key maps to its own stalls
const Hall2_layoutData = NESCO_layoutData.filter(
  (d) => d.hallId === "Hall 2 - BEC",
);
const Hall3_layoutData = NESCO_layoutData.filter(
  (d) => d.hallId === "Hall 3 - BEC",
);
const Hall4_layoutData = NESCO_layoutData.filter(
  (d) => d.hallId === "Hall 4 - BEC",
);
const Hall6_layoutData = NESCO_layoutData.filter(
  (d) => d.hallId === "HALL 6 - BEC",
);
const Hall5_layoutData = NESCO_layoutData.filter(
  (d) => d.hallId === "HALL 5 - BEC",
);
const Aurum_layoutData = NESCO_layoutData.filter(
  (d) => d.hallId === "AURUM_",
);


export const HallLayoutData = {
  // [HALL_KEYS_CONSTANT_DATA.Pavillion]: Hall_Jio_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h1]: Hall1_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h5]: Hall5_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h7]: Hall7_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.JASMINE]: HallJasmine_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.LOTUS_HALL]: HallLotusHall_layoutData,
  // Previous (incorrect): all halls pointed at full NESCO_layoutData
  // [HALL_KEYS_CONSTANT_DATA.h2]: NESCO_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h3]: NESCO_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h4]: NESCO_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h6]: NESCO_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h2]: Hall2_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h3]: Hall3_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h4]: Hall4_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h6]: Hall6_layoutData,
  [HALL_KEYS_CONSTANT_DATA.aurum]: Aurum_layoutData,
};

export const LAYOUT_VENU = "Pavillion";
